import React, { Component } from "react";
import { Button, Form, Input, Checkbox, Alert, Row, Col, message } from "antd";
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import userApi from "../../api/userApi";
import "./Login.scss";
import { Redirect, Router } from "react-router-dom/cjs/react-router-dom.min";
class Login extends Component {

    _form = null;

    constructor(props) {
        super(props);
        this.state = {
            submiting: false,
            info: "",
            isLogin: false
        };
    }

    componentDidMount() {
        const username = localStorage.getItem("username") || "";
    }

    _handleSubmit = (values) => {
        this.setState({ submiting: true });
        let option = {
            username:values.username,
            password:values.password,
        };
        userApi.login(option).then(res => {
            console.log(res.success);
            if(res.success){
                this.props&&this.props.onLogin(true);
                this.setState({ isLogin: true ,submiting: false});
                localStorage.setItem('token', 1);
            }else{
                this.props&&this.props.onLogin(false);
                this.setState({ info: "info" ,submiting: true})
                message.error('登陆失败')
            }
        }).catch(e=>{
            console.log(e);
        })
    }

    render() {
        const { info, submiting, isLogin } = this.state;
        if (isLogin) {
            return <Redirect to="/App"></Redirect>
        }
        return (
            <div className="login-form-root">
                <Row className="login-wrapper">
                    <Col className="left-con" xs={0} sm={0} md={12}></Col>
                    <Col className="right-con" xs={24} sm={24} md={12}>
                        <div className="logo" />
                        <Form className="form-con" size="small" ref={(ref)=>this._form = ref} initialValues={{ remember: true }} onFinish={this._handleSubmit}>
                            <Form.Item label="用户名" name="username" rules={[{ required: true, message: '请输入用户名!' }]}>
                                <Input prefix={<UserOutlined type="user" style={{ color: 'rgba(0,0,0,0.25)' }} />} placeholder="用户名" />
                            </Form.Item>
                            <Form.Item label="密&nbsp;&nbsp;&nbsp;码" name="password" rules={[{ required: true, message: '请输入密码!' }]}>
                                <Input prefix={<LockOutlined type="lock" style={{ color: 'rgba(0,0,0,0.25)' }} />} type="password" placeholder="密码" />
                            </Form.Item>

                            <div className="extra-con">
                                <Form.Item name="remember" valuePropName="checked">
                                    <Checkbox className="cbx_remember">记住用户名</Checkbox>
                                </Form.Item>
                            </div>

                            <footer>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" shape="round" className="ok" loading={submiting}>登录</Button>
                                </Form.Item>
                                {info && <Alert type="warning" message={info} />}
                            </footer>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Login;
// export default Form.create()(Login)